import { atomWithStorage } from 'jotai/utils';

export const XP_API_HOST_ITEM_ID = 'xp-api-host';

export const XP_API_HOST_PRESETS: Record<string, string> = {
  Dev: 'https://api.pathway-dev.cfadevelop.com',
  Test: 'https://api.pathway-test.cfadevelop.com',
  Localhost: 'http://localhost:8080',
};

export const xpApiHostOverrideAtom = atomWithStorage<string | null>(
  'dev-menu-xp-api-host-override',
  null,
  undefined,
  { getOnInit: true },
);
